<template>
  <v-tooltip bottom :color="chipStyle.color" :disabled="impact == null || !text">
    <template #activator="{ on }">
      <v-chip
      v-on="on"
      small
      :color="chipStyle.color"
      :text-color="chipStyle.textColor"
      :outlined="chipStyle.outlined"
      style="max-width: 100%;">
        <v-icon v-if="chipStyle.icon" small left>{{ chipStyle.icon }}</v-icon><span class="text-truncate">{{ label }}</span>
      </v-chip>
    </template>
    <span class="subtitle-1 white--text">{{ $t('conversionImpactTooltip', { impact: impactName }) }}</span>
  </v-tooltip>
</template>

<script>
import { ConversionImpact } from '@/utils/Enumerations.js'
import { conversionImpactStyle } from '@/utils/dueDiligence/presentation.js'

export default {
  name: 'ConversionImpactChip',

  props: {
    impact: {
      type: Number,
      default: null
    },
    text: {
      type: String,
      default: null
    }
  },

  computed: {
    chipStyle () {
      return conversionImpactStyle(this.impact)
    },

    impactName () {
      return ConversionImpact.fromInt(this.impact)
    },

    label () {
      if (this.impact == null) return this.$t('notSpecified')
      return this.text ?? this.impactName
    }
  }
}
</script>
